import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { FormsModule } from '@angular/forms';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';
import { StrakitCheckboxComponent } from '@ngx-strakit/cdk/controls';

@Component({
  selector: 'dms-grid-checkbox-template',
  imports: [
    FormsModule,
    StrakitCheckboxComponent,
    StrakitClickStopPropagationDirective,
  ],
  templateUrl: './dms-grid-checkbox-template.component.html',
  styleUrls: ['./dms-grid-checkbox-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsGridCheckboxTemplateComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public checked = false;
  public readonly hasData = signal(false);

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.hasData.set(!!params.data);
    this.checked = this.params.node.isSelected();
  }

  refresh(params: ICellRendererParams): boolean {
    const wasChecked = this.checked;
    this.agInit(params);

    return wasChecked === this.checked;
  }

  checkboxChange(checked: boolean): void {
    if (this.params.node.isSelected() === checked) {
      return;
    }
    this.params.node.setSelected(checked);
  }
}
